import type { SxProps, Theme } from "@mui/material";

export const tableStyle: SxProps = (theme: Theme) => ({
  background: theme.palette.box1.main,
  mb: 2,
  borderRadius: 2,
  boxShadow: 1,
  color: theme.palette.box1.contrastText,

  // Empty label hotfix
  "& .MuiDataGrid-main": {
    minHeight: "200px",
  },
  "& .MuiDataGrid-overlayWrapper": {
    minHeight: "200px",
  },

  "& .MuiDataGrid-overlay": {
    height: "200px",
  },
  // End

  "& .MuiDataGrid-container--top [role=row]": {
    background: "transparent",
  },

  "& .MuiDataGrid-columnHeader--sortable": {
    cursor: "default",
  },

  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: "bold",
  },

  "& .MuiDataGrid-iconButtonContainer": {
    ml: 2,
  },

  "& .MuiDataGrid-columnSeparator": {
    color: "transparent",
  },

  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },

  "& .MuiDataGrid-row": {
    cursor: "pointer",
  },

  "& .MuiDataGrid-row.Mui-selected": {
    background: "transparent",
  },

  "& .MuiDataGrid-row:hover, & .MuiDataGrid-row.Mui-selected:hover": {
    background: theme.palette.box1.hover,
  },

  "& .MuiDataGrid-filler": {
    display: "none",
  },
});
